import type {GameMode} from "./gameSession";

/**
 * The transfer games the slot can offer (kitecorp/transferify-ui#2874, #2876, #2873) — React-free.
 *
 * Owner decision, 2026-09-24: the player does not choose. Each transfer picks one at random when the
 * Play button first appears, the button names it, and replays after a lost round stay on the same game
 * for that transfer. The ids are also the `game` parameter of every game event, so the A/B results
 * can be read per game.
 */
/**
 * 2048 sits third rather than last so Pack the Zip keeps the top of the draw: its journey pins the page's
 * random source high enough to leave every 7-bag in catalogue order, and the order of this list decides
 * nothing else.
 */
export const GAME_IDS = ["byte_runner", "file_invaders", "2048", "pack_the_zip"] as const;

export type GameId = (typeof GAME_IDS)[number];

/**
 * The Arcade's games: the three the recipient page's arcade picks from (kitecorp/transferify-ui#2889).
 * 2048 joined the senders' pick only (kitecorp/transferify-ui#2873, approved prototype: "sender side
 * only, nothing on the recipient page"), so a game joining the slot does not join the Arcade by that alone.
 */
export const ARCADE_GAME_IDS = ["byte_runner", "file_invaders", "pack_the_zip"] as const satisfies readonly GameId[];

export type ArcadeGameId = (typeof ARCADE_GAME_IDS)[number];

/**
 * One game, evenly, from `random` in `[0, 1)`; a source that answers 1 still lands on the last. The
 * recipient page (`download`) picks from the Arcade's three, the senders' slots from every game.
 */
export function pickGame(random: () => number, mode: GameMode = "upload"): GameId {
	const games: readonly GameId[] = mode === "download" ? ARCADE_GAME_IDS : GAME_IDS;
	return games[Math.min(games.length - 1, Math.floor(random() * games.length))];
}
